import axios from 'axios';
import { Config } from '../utils/config';
import { getAccessToken } from '../utils/sessionStorageUtils';
import { createUnauthenticatedError } from './UnauthenticatedError';

const apiInstance = axios.create({
    baseURL: `${Config.BaseApiUrl}/originations-review-portal`,
});

apiInstance.interceptors.request.use(
    (config) => {
        const accessToken = getAccessToken();

        if (!accessToken) {
            return Promise.reject(createUnauthenticatedError());
        }

        config.headers.Authorization = `Bearer ${accessToken}`;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

export default apiInstance;
